module.exports = __webpack_public_path__ + "img/26_30_bg.733e7642.png";